module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAASCAYAAABFGc6jAAAAAXNSR0IArs4c6QAAASpJREFUSEu91LFOwzAQBuD/riMNYmFgBIkBia0tdIfCxAISD8IrMSJYEaVIGTpUEDYQG4wMXUCFLdxVqeooLXHsqIFMlmzfF5//hPBPD/2F89Ha26gRNyA6rNfjPoVhXDk0ah5sA3ICwNQOg6gXVgrlIADTc3B/e1EZlIsA+kN6vvJw91oJZEMAvgyi7lOSgwn0udvZrCmOkrGyXgeD3otvSHyQFPra6Zyp6PK0uGbfpAj0RWzQ5GAurAySQqP2/hZinGYiWYiVRVIoGfhu9l033/KZ1LmKuOaL7vNXvG3FhBGxoOnb3sITmUkLNr/XGZjsBusH68BKITNhyOvvInfi1brsogRj0mNRZSYSUboyvxXfv4fzRKbQsHG4tsS6/i30tvp4814GMGvHD9OyExO19wYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/activity/three-order-activity/coupon-recevice-gou.png
// module id = v6xM
// module chunks = 4